<template>
    <div class="article-shoes-swayd">
        <p>SwayD make more than just the Alex. Check out their full range!</p>
        <div class="flex flex-row space-x-2">
            <button-primary buttonText="US" buttonUrl="https://swaydshoes.com/ref/60/"></button-primary>
            <button-primary buttonText="Europe" buttonUrl="https://swayd.eu/ref/28/"></button-primary>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ArticleShoesSwayd',
};
</script>
